<template>
  <div class="lessonview mr-10">
    <div class="ml-6">
      <header class="flex justify-between mt-4 mb-3">
        <div class="pl-1">
          <h1 class="font-semibold text-base">{{ lesson.name }}</h1>
          <p class="text-xs">{{ description }}</p>
        </div>

        <div>
          <ul class="actions right">
            <li class="inline">
              <button
                type="button"
                @click="showResources()"
                class="filter-bar-button text-gray-800 hover:opacity-75 focus:outline-none text-xs"
                title="Resources"
              >
                <i class="fas fa-file-download mr-1"></i> Resources
              </button>
            </li>

            <li class="inline">
              <button
                type="button"
                @click="showAttendance()"
                class="filter-bar-button text-gray-800 hover:opacity-75 focus:outline-none text-xs"
                title="Attendance"
              >
                <i class="fas fa-calendar-alt mr-1"></i> Attendance
              </button>
            </li>

            <li class="inline">
              <button
                type="button"
                @click="showPosts()"
                class="filter-bar-button text-gray-800 hover:opacity-75 focus:outline-none text-xs"
                title="Notes"
              >
                <i class="fas fa-comment-alt mr-1"></i> Feedback / Notes
              </button>
            </li>
          </ul>
        </div>
      </header>

      <div class="my-6">
        <div
          v-for="field in fieldList"
          :key="field.model"
          v-bind:class="field.model"
        >
          <div v-if="hasContent(field.model)">
            <div v-if="field.model == 'main-session' && layoutType == 'file'">
              <dynamicfile
                :url="loadFile()"
                :name="fileTitle()"
                class=""
                v-bind:class="isOakAcademy ? 'w-11/12' : 'w-full'"
              ></dynamicfile>

              <div class="mb-4 mt-8 flex w-full" v-if="videosLoaded">
                <div
                  class="video mr-4 mb-4"
                  v-for="video in showVideoList(field.model)"
                  :key="video.identifier"
                >
                  <iframe
                    class="sproutvideo-player"
                    v-bind:src="videoURL(video)"
                    frameborder="0"
                    scrolling="no"
                    allowfullscreen
                  ></iframe>
                </div>
              </div>
            </div>
            <div v-else class="w-full">
              <div
                v-if="showTitle(field.model)"
                class="flex pb-1 mt-5 mb-4 border-b-2 border-list-grey border-solid"
              >
                <h4 class="text-base font-bold w-3/12 flex">
                  <div v-html="setSectionTitle(field)" />
                  <button
                    v-if="!hasDocument"
                    @click="showLessonAltered(field)"
                    class="ml-6 text-sm text-action-blue hover:opacity-50 focus:outline-none"
                  >
                    <i class="fas fa-edit"></i>
                    edit
                  </button>
                </h4>

                <div class="w-9/12 flex justify-end" v-if="diagramsLoaded">
                  <lessonResources :resources="documentFilter(field.model)">
                  </lessonResources>
                </div>
              </div>

              <div class="flex flex-row">
                <div v-if="field.model == 'main-session' && hasDocument">
                  <div class="mb-4 mt-8 flex w-full" v-if="videosLoaded">
                    <div
                      class="video mr-4 mb-4"
                      v-for="video in showVideoList(field.model)"
                      :key="video.identifier"
                    >
                      <iframe
                        class="sproutvideo-player"
                        v-bind:src="videoURL(video)"
                        frameborder="0"
                        scrolling="no"
                        allowfullscreen
                      ></iframe>
                    </div>
                  </div>

                  <dynamicfile
                    :url="loadFile()"
                    :name="fileTitle()"
                    class="w-full"
                  ></dynamicfile>
                </div>

                <div
                  v-else
                  v-bind:class="showDiagram(field.model) ? 'w-3/4' : ''"
                >
                  <div
                    v-html="parseContent(field.model)"
                    class="section-content text-justify"
                  ></div>

                  <div
                    class="flex content-end m-4 mb-3 ml-6"
                    v-if="hasPopupContent(field.model)"
                  >
                    <div
                      @click="showPopupScreen(field.model)"
                      class="more-info w-56 ml-0 p-2 text-center text-sm text-white bg-orange-300 rounded cursor-pointer hover:bg-orange-500"
                    >
                      <i class="fas fa-arrow-alt-circle-right"></i> View
                      {{ popupTitle(field.model) }}
                    </div>

                    <div class="ml-4">
                      <lessonResources
                        :resources="documentFilter(field.model)"
                        :popupDown="true"
                      >
                      </lessonResources>
                    </div>
                  </div>

                  <div class="mb-4 mt-8 flex w-full" v-if="videosLoaded">
                    <div
                      class="video mr-4 mb-4"
                      v-for="video in showVideoList(field.model)"
                      :key="video.identifier"
                    >
                      <iframe
                        class="sproutvideo-player"
                        v-bind:src="videoURL(video)"
                        frameborder="0"
                        scrolling="no"
                        allowfullscreen
                      ></iframe>
                    </div>
                  </div>
                </div>

                <div
                  class="diagrams w-1/4 pl-8"
                  v-if="diagramsLoaded"
                  v-show="showDiagram(field.model)"
                >
                  <div
                    v-for="(pic, index) in diagramFilter(field.model)"
                    :key="index"
                    class="mb-2"
                  >
                    <dynamicimage
                      :url="loadDiagram(pic)"
                      :reference="'ref_' + index"
                      :name="pic.title"
                    ></dynamicimage>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <popupScreen
      :title="selectedPopupTitle"
      :content="selectedPopupContent"
      :videos="selectedPopupVideos"
      :diagrams="selectedPopupDiagrams"
      @close="showPopupModal = false"
      v-if="showPopupModal"
      v-show="showPopupModal"
    ></popupScreen>

    <ModalSlide
      :show="showAttendanceModal"
      :cssWidth="'md:w-6/12'"
      @closeModal="closeAttendanceSelection"
    >
      <template v-slot:header-icon>
        <i class="fas fa-calendar-alt"></i>
      </template>
      <template v-slot:header-title> {{ lesson.name }} Attendance </template>
      <template v-slot:body>
        <Attendance
          :lesson="lesson"
          :key="'attendance' + lesson.id"
          :pupils="pupils"
        ></Attendance>
      </template>
    </ModalSlide>

    <ModalSlide :show="showPostsModal" @closeModal="closePostsSelection">
      <template v-slot:header-icon>
        <i class="fas fa-comment-alt"></i>
      </template>
      <template v-slot:header-title>
        {{ lesson.name }} Notes / Feedback
      </template>
      <template v-slot:body>
        <LessonPosts :lesson="lesson" :key="'posts' + lesson.id"></LessonPosts>
      </template>
    </ModalSlide>

    <ModalSlide
      :show="showResourcesModal"
      @closeModal="showResourcesModal = false"
    >
      <template v-slot:header-icon>
        <i class="fas fa-folder"></i>
      </template>
      <template v-slot:header-title> Unit Files & Resources </template>
      <template v-slot:body>
        <UnitFileList
          :course="course"
          :lesson="lesson"
          :lessonFiles="lessonFiles"
          :key="'files' + course.id"
        ></UnitFileList>
      </template>
    </ModalSlide>

    <ModalSlide
      v-if="selectedEditField != undefined"
      :show="showLessonAlteredModal"
      @closeModal="showLessonAlteredModal = false"
    >
      <template v-slot:header-icon>
        <i class="fas fa-edit"></i>
      </template>
      <template v-slot:header-title>
        Lesson Alteration @ {{ selectedEditField.name }}
      </template>
      <template v-slot:body>
        <LessonAltered
          @refresh="refreshLesson"
          :displayField="selectedEditField"
          :lesson="lesson"
          :altered="alteredLessonSection"
          :key="'altering' + lesson.id"
        ></LessonAltered>
      </template>
    </ModalSlide>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { lessonContentMixin } from "@/mixins/lessonContentMixin.js";

import { SchoolService } from "@/services/school.service";

const dynamicimage = () => import("@/components/DynamicImage.vue");
const dynamicfile = () => import("@/components/DynamicFile.vue");
const popupScreen = () => import("@/components/LessonContentModal.vue");
const lessonResources = () =>
  import("@/components/curriculum/LessonResources.vue");
const UnitFileList = () => import("@/components/curriculum/TheUnitFileList");
const LessonPosts = () => import("@/components/curriculum/LessonPosts.vue");

const LessonAltered = () =>
  import("@/components/curriculum/TheLessonAltered.vue");
const ModalSlide = () => import("@/components/ModalSlide.vue");
const Attendance = () =>
  import("@/components/curriculum/TheLessonAttendance.vue");

export default {
  name: "lessonview",
  mixins: [lessonContentMixin],
  props: {
    course: Object,
    pupils: Array,
    lesson: { type: Object, required: true },
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
      settings: "settings",
    }),
    description() {
      return "Lesson content, resources and plan.";
    },
    videosLoaded() {
      return this.videos.length > 0;
    },
    diagramsLoaded() {
      return this.resources.length > 0;
    },
    layoutType() {
      return this.lesson.layout;
    },
    hasDocument() {
      return (
        this.layoutType != undefined &&
        this.layoutType.length != 0 &&
        this.lesson.document_url != null &&
        this.lesson.document_url.length > 3
      );
    },
    isOakAcademy() {
      return this.course.category.key_value;
    },
  },
  data() {
    return {
      errored: false,
      showPopupModal: false,
      videos: [],
      resources: [],
      selectedPopupTitle: "",
      selectedPopupContent: "",
      selectedPopupVideos: [],
      selectedPopupDiagrams: [],

      showAttendanceModal: false,
      showPostsModal: false,

      lessonFiles: [],
      showResourcesModal: false,

      alteredList: [],
      alteredLessonSection: undefined,
      selectedEditField: undefined,
      showLessonAlteredModal: false,
    };
  },
  created() {
    this.fetchAltered();
  },
  mounted() {
    this.fetchVideos();
    this.fetchResources();
  },
  methods: {
    fetchAltered() {
      SchoolService.getAll("lessons/" + this.lesson.id + "/altered")
        .then((response) => (this.alteredList = response.data.data))
        .catch((err) => {
          console.log(" alterd" + err);
          this.errored = true;
        })
        .finally(() => (this.errored = false));
    },
    fetchVideos() {
      SchoolService.getAll("lessons/" + this.lesson.id + "/videos")
        .then((response) => this.buildVideoList(response.data.data))
        .catch((err) => {
          console.log(" videos" + err);
          this.errored = true;
        })
        .finally(() => (this.errored = false));
    },
    buildVideoList(data) {
      this.videos = data;
    },
    fetchResources() {
      SchoolService.getAll("lessons/" + this.lesson.id + "/resources")
        .then((response) => this.buildResourceList(response.data.data))
        .catch((err) => {
          console.log(" resources" + err);
          this.errored = true;
        })
        .finally(() => (this.errored = false));
    },
    buildResourceList(data) {
      this.resources = data;
      this.lessonFiles = this.resources.filter(function (r) {
        return r.format != "diagram";
      });
      if (
        this.course.category.key_value != "concept" &&
        (this.lesson.document_url != null || this.lesson.document_url != "") &&
        ["file", "fields"].includes(this.lesson.layout)
      ) {
        const document = {
          format: "teaching",
          title: this.lesson.name + " session",
          url: this.lesson.document_url,
          display_order: 1,
        };
        this.lessonFiles.push(document);
      }
    },
    showAttendance() {
      this.showAttendanceModal = true;
    },
    closeAttendanceSelection() {
      this.showAttendanceModal = false;
    },
    showPosts() {
      this.showPostsModal = true;
    },
    closePostsSelection() {
      this.showPostsModal = false;
    },
    showResources() {
      this.showResourcesModal = true;
    },
    closeResourcesSelection() {
      this.showResourcesModal = false;
    },
    showLessonAltered(field) {
      this.selectedEditField = field;
      this.alteredLessonSection = this.findAlteredLesson(field.model);
      this.showLessonAlteredModal = true;
    },
    refreshLesson() {
      this.showLessonAlteredModal = false;
      this.fetchAltered();
      this.$forceUpdate();
    },
    findAlteredLesson(section) {
      return this.alteredList.find((al) => {
        if (al.share_level > 0) {
          return (
            al.display_key === section &&
            al.user_id === this.currentUser.teacherID
          );
        } else {
          return al.display_key === section;
        }
      });
    },
    getContent(section) {
      let altered = this.findAlteredLesson(section);
      return this.processContent(section, this.lesson, altered);
    },
    videoFilterList(section) {
      return this.videos.filter((v) => {
        var filtered = true;

        console.log("SECTUION", section);

        if (section.trim() === "outline") {
          filtered = ["outline", "objective"].includes(v.display_key);
        } else {
          filtered = v.display_key == section.trim();
        }

        return filtered;
      });
    },
    videoFilter(section) {
      return this.videoFilterList(section);
    },
    diagramFilter(section) {
      return this.resources.filter((v) => {
        return v.display_key == section && v.format == "diagram";
      });
    },
    documentFilter(section) {
      return this.resources.filter((v) => {
        var filtered = true;

        filtered = v.format == "document";

        if (filtered) {
          if (section === "outline") {
            filtered = ["outline", "introduction"].includes(v.display_key);
          } else {
            filtered = v.display_key == section;
          }
        }

        return filtered;
      });
    },
    hasContent(section) {
      if (section === "main-session" && this.layoutType == "file") {
        return true;
      } else if (section === "main-session" && this.hasDocument) {
        return true;
      } else {
        return this.getContent(section).length != 0;
      }
    },
    hasPopupContent(section) {
      switch (section) {
        case "outline":
          return (
            this.lesson.introduction != null &&
            this.lesson.introduction.length > 0
          );
        case "main-session":
          return (
            this.lesson.activities != null && this.lesson.activities.length > 0
          );
        default:
          return false;
      }
    },

    showPopupScreen(section) {
      if (["outline", "main-session"].includes(section) === false) {
        return;
      }

      let title =
        section === "outline" ? "Introduction" : "Additional Activities";
      this.selectedPopupTitle = this.lesson.name + " " + title;

      let contentSection = section == "outline" ? "introduction" : "activities";
      this.selectedPopupContent = this.parseContent(contentSection);
      this.selectedPopupVideos = this.videoFilterList(contentSection);
      this.selectedPopupDiagrams = this.diagramFilter(contentSection);
      this.showPopupModal = true;
    },
    setSectionTitle(field) {
      let altered = this.findAlteredLesson(field.model);
      return this.processSectionTitle(
        this.course.subject_id,
        field,
        this.lesson,
        altered
      );
    },
    showVideoList(value) {
      return this.videoFilter(value);
    },
    showDiagram(value) {
      return this.diagramFilter(value)[0] != undefined;
    },
    loadDiagram(diagram) {
      return diagram.folder + "/" + diagram.url;
    },
    loadFile() {
      return this.lesson.document_url;
    },
    fileTitle() {
      return this.lesson.name;
    },
    videoURL(video) {
      return (
        video.service_url_b +
        "?autoPlay=false&amp;playerTheme=dark&amp;playerColor="
      );
    },
  },
  components: {
    dynamicimage,
    dynamicfile,
    popupScreen,
    lessonResources,
    ModalSlide,
    Attendance,
    LessonPosts,
    UnitFileList,
    LessonAltered,
  },
};
</script>

<style scoped>
.outline {
  background-color: #f6f6f6;
  display: block;
  border-bottom-right-radius: 4px;
  border-bottom-left-radius: 4px;
  margin-top: 0px !important;
  margin-bottom: 2em !important;
  padding-top: 1em !important;
  padding-bottom: 1em !important;
}

.outline .section-content {
  padding-left: 1.5em !important;
  padding-bottom: 0.5em;
  padding-right: 1.5em;
  padding-top: 0.5em;
  font-size: 1.1em;
  font-weight: 700;
}

.outline .more-info {
  @apply ml-6;
}

.video {
  width: 610px;
  height: 345px;
  border-radius: 14px;
  overflow: hidden;
  position: relative;
  border: 2px solid #3e4448;
  background-color: #3e4448;
}

.video iframe {
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
}

h1 {
  @apply text-lg font-bold;
}

ul.actions li {
  padding: 0;
}

.outline .section-content h2 {
  margin-top: 1rem !important;
}
</style>
